export default function getNavbarsHeight() {
  return [
    '.application-navbar', '.mobile-navbar',
  ]
    .reduce((aggregate, selector) => {
      const el = $(selector);
      const elHeight = el.is(':visible') ? el.height() : 0;

      return aggregate + elHeight;
    }, 0);
}
